class AnimatedText extends HTMLElement {
  constructor() {
    super();
    this.strings = Array.from(this.getAttribute('type-terms').split(',')) || [];
    const loop = this.getAttribute('type-terms-loop') || false;

    this.options = {
      strings: this.strings,
      typeSpeed: Number(this.getAttribute('type-terms-speed')) || 0,
      loop: loop === 'true',
      attr: this.getAttribute('type-terms-attr') || null,
    }

    this.animatedText = new Typed(this, {
      strings: this.options.strings,
      typeSpeed: this.options.typeSpeed,
      backSpeed: (this.options.typeSpeed * 1.5),
      backDelay: 2000,
      loop: this.options.loop,
      attr: this.options.attr,
      shuffle: false,
      startDelay: 100,
      onStop: (_, self) => {
        clearInterval(self.timeout)
      }
    })
  }

  connectedCallback() {
    setTimeout(() => {
      this.animatedText.start();
    }, 3000);
  }

  disconnectedCallback() {
    this.animatedText.destroy();
  }
}

if (!customElements.get('animated-text')) {
  customElements.define('animated-text', AnimatedText)
}
